import { EXIT_DATE_ALIAS } from 'common/constants/allocations';
import enterpriseValue from 'dashboard409a/components/Valuation/Components/EnterpriseValue/EnterpriseValue';
import CompanyList from 'pages/Waterfall/components/CompanyList/CompanyList';
import CompanyListValueViewer from 'pages/Waterfall/components/CompanyList/CompanyListValueViewer';
import MeasurementDateList from 'pages/Waterfall/components/MeasurementDateList/MeasurementDateList';
import MeasurementDateListValueViewer from 'pages/Waterfall/components/MeasurementDateList/MeasurementDateValueViewer';
import {
  CAP_TABLE_ALIAS,
  COMPANY_ALIAS, EXIT_ENTERPRISE_VALUE_ALIAS,
  EXIT_EQUITY_ALIAS,
  FIRM_TOTAL_EXIT_PROCEEDS_ALIAS, LESS_DEBT_ALIAS,
  MEASUREMENT_DATE_ALIAS, PLUS_CASH_ALIAS,
} from 'pages/Waterfall/SpreadsheetConfig/constants';
import { InputSheetRowConfigProps } from './inputSheetRowConfig.props';
import { largeCurrencyFormat } from '../../../../../common/formats/formats';
import { SelectValueViewer } from '../../../../../components';
import { GridDateEditor, GridDateValueViewer } from '../../../../../components/FeaturedSpreadsheet/components';
import CaptableList from '../../../components/CaptableList/CaptableList';

const inputSheetRowConfig = ({
  exitDate,
  capTableId,
  equityValue,
  enterpriseValue,
  plusCash,
  lessDebt,
  firmOptions,
  childrenCapTables,
  parentCapTables,
  exitProceedsExpression,
}: InputSheetRowConfigProps) => {
  const allCaptables = [...(parentCapTables ?? []), ...childrenCapTables];
  const rows = [
    {
      headerValue: 'Cap Table',
      alias: CAP_TABLE_ALIAS,
      headerAlias: 'cap_table_header',
      value: capTableId || undefined,
      dataEditor: (props: any) => <CaptableList {...props} childrenCapTables={childrenCapTables} />,
      valueViewer: (props: any) => <SelectValueViewer {...props} useAliasList={false} options={allCaptables} />,
    },
    {
      headerValue: 'Exit Date',
      alias: EXIT_DATE_ALIAS,
      headerAlias: 'exit_date_header',
      value: exitDate || '',
      valueViewer: (props: any) => <GridDateValueViewer {...props} />,
      dataEditor: (props: any) => <GridDateEditor {...props} />,
    },
    {
      headerValue: 'Exit Enterprise Value',
      alias: EXIT_ENTERPRISE_VALUE_ALIAS,
      headerAlias: `${EXIT_ENTERPRISE_VALUE_ALIAS  }_header`,
      value: enterpriseValue,
      format: largeCurrencyFormat,
    },
    {
      headerValue: 'Plus Cash',
      alias: PLUS_CASH_ALIAS,
      headerAlias: `${PLUS_CASH_ALIAS  }_header`,
      value: plusCash,
      format: largeCurrencyFormat,
      readOnly: true,
    },
    {
      headerValue: 'Less Debt',
      alias: LESS_DEBT_ALIAS,
      headerAlias: `${LESS_DEBT_ALIAS  }_header`,
      value: lessDebt,
      format: largeCurrencyFormat,
      readOnly: true,
    },
    {
      headerValue: 'Exit Equity Value',
      alias: EXIT_EQUITY_ALIAS,
      headerAlias: 'exit_equity_value_header',
      value: equityValue,
      format: largeCurrencyFormat,
    },
    {
      headerValue: 'Firm Total Exit Proceeds',
      alias: FIRM_TOTAL_EXIT_PROCEEDS_ALIAS,
      value: undefined,
      headerAlias: `${FIRM_TOTAL_EXIT_PROCEEDS_ALIAS}_header`,
      format: largeCurrencyFormat,
      expr: exitProceedsExpression,
    },
  ];
  if (firmOptions) {
    const firmOptionRows = [
      {
        headerValue: 'Company Name',
        alias: COMPANY_ALIAS,
        headerAlias: 'company_header',
        value: firmOptions.companyId,
        valueViewer: (props: any) => <CompanyListValueViewer {...props} />,
        dataEditor: (props: any) => <CompanyList {...props} />,
      },
      {
        headerValue: 'Measurement Date',
        alias: MEASUREMENT_DATE_ALIAS,
        headerAlias: 'measurement_date_header',
        value: firmOptions.measurementDateId,
        valueViewer: (props: any) => <MeasurementDateListValueViewer {...props} />,
        dataEditor: (props: any) => <MeasurementDateList {...props} />,
      },
    ];
    return [...firmOptionRows, ...rows];
  }
  return rows;
};

export default inputSheetRowConfig;
